// import { Component, OnInit } from '@angular/core';
// import { DatePipe } from '@angular/common';

// @Component({
//   selector: 'qr-code',
//   templateUrl: './qr-code.component.html',
//   // styleUrls: ['./certificate.component.scss'],
// })
// export class QrCodeSTPComponent implements OnInit {
//   public qrdata = 'myAngularxQrCode';

//   constructor () {
//     // assign a value
//     // this.myAngularxQrCode = 'Your QR code data string';
//   }
//   ngOnInit(): void {}
// }

import { Component, OnInit, VERSION } from '@angular/core';
import { DatePipe } from '@angular/common';
import {
  NgxQrcodeElementTypes,
  NgxQrcodeErrorCorrectionLevels,
} from '@techiediaries/ngx-qrcode';

@Component({
  selector: 'qr-code',
  templateUrl: './qr-code.component.html',
  // styleUrls: ['./certificate.component.scss'],
})
export class QrCodeSTPComponent implements OnInit {
  title: string;
  name: string;
  elementType: string;
  correctionLevel: string;
  stpMainId: string;
  value: string;

  constructor() {
    // assign a value
    // this.myAngularxQrCode = 'Your QR code data string';
  }
  ngOnInit(): void {
    this.qrCode();
  }

  qrCode() {
    this.title = 'QRcodes';
    this.name = 'Angular' + VERSION.major;
    this.elementType = NgxQrcodeElementTypes.URL;
    this.correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
    console.log('incept QR code : ' + this.stpMainId);
    this.value =
      'http://skillsportal.gov.bd/home/stp-registration/certificate-verification-page/' +
      this.stpMainId;
  }
}


